/** 
 * 停车场
 *  */ 

export const PARKINGPUBLICQUERY = "PARKINGPUBLICQUERY"  // 停车场列表


// WEBPACK FOOTER //
// ./src/store/parking/types.js